import React from 'react'
import Moment from 'moment'
import { withBalanceContainer, Table, ChevronLeft, ChevronRight } from "../../normalizer"
import { withRouter } from 'react-router-dom'
import HistoryTable from './HistoryTable'
import CustomButton from '../../shared/CustomButton'
import CustomSelect from '../../shared/CustomSelect'
import { prefix } from '../../../../i18n'

const TIME_INTERVALS = [
  { id: '1month',  name: '1 mês'   },
  { id: '3months', name: '3 meses' },
  { id: '6months', name: '6 meses' },
]

const HistoryYearSelect = ({ selectedDate, onChangeEvent }) => {
  const minYear = 2015
  const currentYear = Moment().year()
  const years = Array.from({ length: currentYear - minYear }, (_, i) => ({
    id: currentYear - i,
    name: currentYear - i,
  }))
  const selectedYear = years.find(y => y.id === selectedDate.year())
  return (
    <CustomSelect
      onChange={onChangeEvent}
      options={years}
      optionsLabel="name"
      optionsId="id"
      selectedValue={selectedYear}
      noMessage="Sem anos"
    />
  )
}

const HistoryMonthSelect = ({ selectedDate, onChangeEvent }) => {
  const tMonth = prefix('months')
  const months = Moment.months().map((month, i) => ({ name: tMonth(month), id: i }))
  const selectedMonth = months.find(m => m.id === selectedDate.month())
  return (
    <CustomSelect
      onChange={onChangeEvent}
      options={months}
      optionsLabel="name"
      optionsId="id"
      selectedValue={selectedMonth}
      noMessage="Sem meses"
    />
  )
}

const BalanceHistory = (props) => {
  const {
    historyMonths,
    historyPoints,
    onChangeTimePeriod,
    selectedTime,
    onChangeNextMonth,
    onChangePrevMonth,
    selectedDate,
    onChangeMonth,
    onChangeYear,
    historyRange,
    history,
  } = props

  const selectedInterval = TIME_INTERVALS.find(t => t.id === selectedTime) || TIME_INTERVALS[1]

  return (
    <div className="balance-history">
      <div className="balance-history__top">
        <CustomButton secondary onClick={() => history.push('/profile/balance')}>
          <Table width={16} height={16} />
          Ver tabela normal
        </CustomButton>
      </div>

      <div className="balance-history__filters">
        <div className="balance-history__filter">
          <span className="balance-history__filter-label">Mês</span>
          <HistoryMonthSelect selectedDate={selectedDate} onChangeEvent={onChangeMonth} />
        </div>
        <div className="balance-history__filter">
          <span className="balance-history__filter-label">Ano</span>
          <HistoryYearSelect selectedDate={selectedDate} onChangeEvent={onChangeYear} />
        </div>
        <div className="balance-history__filter">
          <span className="balance-history__filter-label">Intervalo de tempo</span>
          <CustomSelect
            onChange={(opt) => onChangeTimePeriod(opt.id)}
            options={TIME_INTERVALS}
            optionsLabel="name"
            optionsId="id"
            selectedValue={selectedInterval}
            noMessage="Sem opções"
          />
        </div>
      </div>

      <div className="balance-history__table-card">
        <div className="balance-history__table-nav">
          <button type="button" className="balance-history__nav-btn" onClick={onChangePrevMonth} aria-label="Anterior">
            <ChevronLeft width={16} height={16} />
          </button>
          <span className="balance-history__range">{historyRange}</span>
          <button type="button" className="balance-history__nav-btn" onClick={onChangeNextMonth} aria-label="Seguinte">
            <ChevronRight width={16} height={16} />
          </button>
        </div>
        <HistoryTable headers={historyMonths} data={historyPoints} />
      </div>
    </div>
  )
}

export default withBalanceContainer(withRouter(BalanceHistory))